import { render } from "./ScheduledTable.vue?vue&type=template&id=dbfd41f8&scoped=true"
import script from "./ScheduledTable.vue?vue&type=script&lang=js"
export * from "./ScheduledTable.vue?vue&type=script&lang=js"

import "./ScheduledTable.vue?vue&type=style&index=0&id=dbfd41f8&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbfd41f8"]])

export default __exports__